/**This file contains a constant object that has properties that are necessary
 * for the build found in the `prod` configuration in `angular.json`.
 */

export const environment = {
	environment:'Production',
	baseUrl:'',
	production: true,
	openidUrl:"",
	openidClientId:"",
	openidResource:"",
	digUrl:"https://build.ford.com/dig",
	applicationId:"bea997ee-7fdd-492f-a2db-d7f621b0f39c",
	syndicatedUrl:"https://www.lincoln.com/aemservices/brand/syndicatedModulesAsHtml.set-credit.header.footer.json",
	baseJsUrl:"https://www.lincoln.com/etc/designs/brand_ford/brand/syn/lincoln/base.min.js",
	headerJsUrl:"https://www.lincoln.com/etc/designs/brand_ford/brand/syn/lincoln/header.min.js",
	footerJsUrl:"https://www.lincoln.com/etc/designs/brand_ford/brand/syn/lincoln/footer.min.js",
	dynatraceUrl: "https://js-cdn.dynatrace.com/jstag/19223e8e12b/bf87003hfh/6e961d63cb2f94f9_complete.js",
	modelSliceURL:"https://www.cxservices.ford.com/products/ModelSlices.json",
	vehicleCallUrl:"https://www.ford.com/cxservices/products/ModelSlices.json?appContext=SHOWROOM&filters=Showroom_Is_Displayed:true&make=Lincoln&modelAttributes=nameplateDisplayNameShort&planType=MSRP",
	site:"lincoln.com/finance",
	postalCodeURL:"https://www.cxservices.ford.com/geo/PostalCodes.json",
	preconnectBaseUrls: [
		"https://www.lincoln.com",
		"https://build.ford.com",
		"https://www.cxservices.ford.com",
		"https://code.jquery.com",
		"https://assets.adobedtm.com"
	],
	validUSHostList: [
		"localhost",
		"www.globalfinancecalculator.ford.com",
		"www.lincoln.com/finance/payment-calculator",
		"www.lincoln.com/finance/payment-calculator/",
		"www.lincolnfinancecalculator.ford.com/finance/payment-calculator",
		"www.lincoln.com",
		"lincolnpaymentestimator.apps.pd01i.edc2.cf.ford.com",
		"www.lincolnfinancecalculator.ford.com",
		"gfc-na-lincoln-paymentestimator-4dzunwndla-uc.a.run.app",
		"lincoln-pe-web-prd-433925830461.us-central1.run.app",
		"lincoln-pe-web-prd-4dzunwndla-uc.a.run.app"
	],

	accountManagerNavigation:"https://accountmanager.lincoln.com/fma-login-redirect",
	validSingleHost:"",
	cluster5Call:"https://api.pd01e.gcp.ford.com/fccfcWAR/rest/v1/calculatePayment",
	calculatePaymentCall:"https://api.fordcredit.com/api/na/paymentEstimator/calculatePayment",
	OAUTH:"https://api.pd01e.gcp.ford.com/auth/api/v1/token",
	homeNavigation:"https://www.lincoln.com/finance",
	dataAppId:"de0bb807-54aa-4c10-b1ee-56a46c097854",
	dataOrgId:"3a9c591f-da14-4867-8aec-cfd07a2d8327",
	dataOrgUrl:"https://org4b0e0f2e-crm.omnichannelengagementhub.com",
	lincolnPeWebKey: {

		environment: 'Production',
		baseUrl: '',
		production: true,
		openidUrl: "",
		openidClientId: "",
		openidResource: "",
		digUrl: "https://build.ford.com/dig",
		applicationId: "bea997ee-7fdd-492f-a2db-d7f621b0f39c",
		syndicatedUrl: "https://www.lincoln.com/aemservices/brand/syndicatedModulesAsHtml.set-credit.header.footer.json",
		baseJsUrl: "https://www.lincoln.com/etc/designs/brand_ford/brand/syn/lincoln/base.min.js",
		headerJsUrl: "https://www.lincoln.com/etc/designs/brand_ford/brand/syn/lincoln/header.min.js",
		footerJsUrl: "https://www.lincoln.com/etc/designs/brand_ford/brand/syn/lincoln/footer.min.js",
		modelSliceURL: "https://www.cxservices.ford.com/products/ModelSlices.json",
		vehicleCallUrl: "https://www.ford.com/cxservices/products/ModelSlices.json?appContext=SHOWROOM&filters=Showroom_Is_Displayed:true&make=Lincoln&modelAttributes=nameplateDisplayNameShort&planType=MSRP",
		site: "lincoln.com/finance",
		postalCodeURL: "https://www.cxservices.ford.com/geo/PostalCodes.json",
		preconnectBaseUrls: [
			"https://www.lincoln.com",
			"https://build.ford.com",
			"https://www.cxservices.ford.com",
			"https://code.jquery.com",
			"https://assets.adobedtm.com"
		],
		validUSHostList: [
			"localhost",
			"www.globalfinancecalculator.ford.com",
			"www.lincoln.com/finance/payment-calculator",
			"www.lincoln.com/finance/payment-calculator/",
			"www.lincolnfinancecalculator.ford.com/finance/payment-calculator",
			"www.lincoln.com",
			"lincolnpaymentestimator.apps.pd01i.edc2.cf.ford.com",
			"www.lincolnfinancecalculator.ford.com",
			"gfc-na-lincoln-paymentestimator-4dzunwndla-uc.a.run.app",
			"lincoln-pe-web-prd-433925830461.us-central1.run.app",
			"lincoln-pe-web-prd-4dzunwndla-uc.a.run.app"
		],

		accountManagerNavigation: "https://accountmanager.lincoln.com/fma-login-redirect",
		validSingleHost: "",
		cluster5Call: "https://api.pd01e.gcp.ford.com/fccfcWAR/rest/v1/calculatePayment",
		calculatePaymentCall: "https://api.fordcredit.com/api/na/paymentEstimator/calculatePayment",
		OAUTH: "https://api.pd01e.gcp.ford.com/auth/api/v1/token",
		homeNavigation: "https://www.lincoln.com/finance",
		dataAppId: "de0bb807-54aa-4c10-b1ee-56a46c097854",
		dataOrgId: "3a9c591f-da14-4867-8aec-cfd07a2d8327",
		dataOrgUrl: "https://org4b0e0f2e-crm.omnichannelengagementhub.com"
	}
};
